var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#2D66A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.094 7.02278C16.7334 6.64257 16.1322 6.62582 15.7514 6.98732L9.68854 12.7371L6.79672 9.76805C6.43046 9.39227 5.82995 9.38404 5.45385 9.75034C5.07807 10.1163 5.07016 10.7174 5.4361 11.0932L8.98164 14.7334C9.16745 14.9243 9.41438 15.0205 9.66196 15.0205C9.89686 15.0205 10.1318 14.9338 10.3157 14.76L17.0585 8.36538C17.439 8.00447 17.4551 7.40331 17.094 7.02278Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveTick);
export default __webpack_public_path__ + "static/media/active_tick.31733b5fec04ae27863e5581204c9f52.svg";
export { ForwardRef as ReactComponent };